import { render, staticRenderFns } from "./ServiceVisits.vue?vue&type=template&id=6cd8a9f2&"
import script from "./ServiceVisits.vue?vue&type=script&lang=js&"
export * from "./ServiceVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports